<template>
    <v-container>
        <v-row class="py-0">
            <v-col cols="6" sm="3"></v-col>
            <v-col cols="6" sm="9">
                <v-form v-model="valid" lazy-validate>
                    <v-text-field
                            label="Search by Email"
                            dense
                            :prepend-icon="icons.search"
                            outlined
                            v-model="string"
                            :rules="[rules.emailRules]"
                            clearable
                            @click:clear="resetApp()"
                            @click:prepend="searchByString()"
                    />
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card outlined flat v-if="org">
                    <v-card-text>
                        <span class="title ml-4 awesome--text">
                            {{items.length}} records
                            <v-btn @click="getCustomers()" depressed small rounded :loading="loading" color="awesome" dark>
                                <span v-if="PaginationToken">More</span>
                                <span v-else>Beginning</span>
                                <v-icon v-if="PaginationToken" >{{icons.arrowright}}</v-icon>
                                <v-icon v-else >mdi-subdirectory-arrow-left</v-icon>
                            </v-btn>
                        </span>
                        <template>
                            <v-data-table
                                :key="tablekey"
                                :headers="headers"
                                :items="items"
                                :items-per-page="60"
                                @click:row="searchUsers($event)"
                                sort-by="email"
                                sort-asc
                                hide-default-footer
                            >
                            </v-data-table>
                        </template>
                    </v-card-text>
                </v-card>
                <v-btn dark :loading="loading" color="awesome"  @click="getCustomers()" fab fixed bottom right>
                    <v-icon v-if="PaginationToken" >{{icons.arrowright}}</v-icon>
                    <v-icon v-else >mdi-subdirectory-arrow-left</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog
                v-model="dialog"
                v-if="activeuser"
                :fullscreen="$vuetify.breakpoint.xs"
                max-width="400"
                scrollable
        >
            <v-card>
                <v-card-title>
                    Enabled: {{activeuser.user.Enabled}}
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item  v-for="u in activeuser.user.UserAttributes" :key="u.Value">
                            <v-list-item-content>
                                <v-list-item-title class="text-capitalize">{{u.Name}}</v-list-item-title>
                                <v-list-item-subtitle>{{u.Value}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-list dense v-if="activeuser.userappdata && activeuser.userappdata.stripe">
                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title>
                                    Orders
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item v-for="(o,i) in custorders" :key="i" @click="activeorder=o,orderdialog=true">
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{o.description.name}}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    ${{o.amount/100}} | {{new Date(o.createdAt).toDateString()}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                    </v-list>

                    <v-card outlined>
                        <v-list>
                            <v-list-item v-if="!resetpassword" @click="resetpassword=true">
                                <v-list-item-content>
                                    <v-list-item-title class="text-capitalize">Reset Passwords</v-list-item-title>
                                    <v-list-item-subtitle>Reset</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-else @click="justSendMeOne()" >
                                <v-list-item-content class="warning--text">
                                    <v-list-item-title class="text-capitalize">Confirm Reset Password</v-list-item-title>
                                    <v-list-item-subtitle>Click to reset the users password</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action :loading="true">
                                    <v-btn icon :loading="sendingreset">
                                        <v-icon>mdi-form-textbox-password</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item v-if="resetpassword" >
                                <v-list-item-content class="warning--text font-weight-light text-justify">
                                    Password reset will override existing password. User/Customer will need to retrieve the
                                    generated password from their email within 24 hours and log in.
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="resetpassword" @click="resetpassword=false" >
                                <v-list-item-content class="info--text">
                                    Cancel Reset
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon>{{icons.cancel}}</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item v-if="message">
                                <v-list-item-content class="info--text">
                                    {{message.text}}
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                    <v-card outlined v-if="org.partkey==='athleteforlifev2'">
                        <v-card-text>
                            <v-text-field outlined title="Club Director" v-model="directorof" />
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="closeUser()">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="orderdialog"
                v-if="activeorder"
                max-width="350"
        >
            <v-card>
                <v-card-title>Order</v-card-title>
                <v-card-text v-if="activeorder.orderdata">
                    <div>Amount: {{activeorder.orderdata.charge.amount}}</div>
                    <div>On: {{ new Date(activeorder.orderdata.charge.created*1000).toUTCString()}} </div>
                    <div>Card Id: {{activeorder.orderdata.card.id}}</div>
                    <div>Card #: xxxx-xxxx-xxxx-{{activeorder.orderdata.card.last4}}</div>
                    <div>Exp {{activeorder.orderdata.card.exp_month}}/{{activeorder.orderdata.card.exp_year}}</div>
                    <div>Fingerprint "{{activeorder.orderdata.card.fingerprint}}"</div>
                    <div>Charge Id: "{{activeorder.orderdata.charge.id}}"</div>
                    <v-divider></v-divider>
                    <div class="font-weight-light title">Order Items:</div>
                    <div v-for="t in activeorder.orderdata.paid.items" :key="t.description" class="font-weight-medium px-1" style="background-color: lightgrey;">
                        <div>Amount: {{t.amount}}</div>
                        <div>Description: {{t.description}}</div>
                        <div>Parent: {{t.parent}}</div>
                        <div>Type: {{t.type}}</div>
                        <v-divider></v-divider>
                    </div>
                    <v-divider></v-divider>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="orderdialog=false,activeorder=undefined,directorof=undefined">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  //42a393f9-8553-4e4a-a9bc-d3cc4402028e
  export default {
    name: "Customers",
    data() {
      return {
        valid:false,
        string:undefined,
        activeproduct: false,
        activeevent: false,
        skus: [],
        step: 1,
        product: false,
        eventviewdialog: false,
        headers: [
          {
            text: 'Email',
            align: 'left',
            value: 'email',
          }
        ],
        items: [],
        tablekey:'000',
        PaginationToken: undefined,
        dialog: undefined,
        activeuser: undefined,
        loading:false,
        sendingreset:false,
        message: undefined,
        custorders:undefined,
        resetpassword:false,
        activeorder:undefined,
        orderdialog:true,
        directorof: undefined
      }
    },
    computed: {
      ...mapState(['org', 'icons','rules','appdata'])
    },
    mounted() {
        this.getCustomers()
    },
    methods: {
      ...mapActions(['post', 'get']),
      async getCustomers(){
        this.loading = true
        let data = await this.post({path:'api/users/list',body:{PaginationToken:this.PaginationToken}})
        this.loading=false
        this.items = data.users;
        this.PaginationToken = data.PaginationToken
        this.tablekey = new Date().getTime()
      },
      async searchByString(){
        if(!this.valid||!this.string)return
        this.loading = true
        let data = await this.post({path:'api/users/searchbystring',body:{string: this.string}})
        this.loading = false
        if(data.error){
          this.error = data.error
        } else {
          this.activeuser = data;
          this.dialog = true;
          if(data.userappdata){
            this.userOrders(data.userappdata.partkey)
          }
        }
      },
      async searchUsers(item){
        this.directorof=undefined
        let data = await this.post({path:'api/users/searchuser',body:{sub:item.sub}})
        if(data.error)return
        console.log(data)
        if(data.userappdata){
          this.userOrders(data.userappdata.partkey)
          let keys = []
          if(data.userappdata.orgs){
            keys =  Object.keys(data.userappdata.orgs)
          }
          if(keys.length>0){
            console.log(keys)
            this.directorof=data.userappdata.orgs[keys[0]].name
          }
        }
        this.activeuser = data;
        this.dialog = true;
      },
      async justSendMeOne(){
        let body = {}
        this.activeuser.user.UserAttributes.forEach(f=>{
          body[f.Name]=f.Value
        })
        body.username = this.activeuser.user.Username
        this.sendingreset = true
        let res = await this.post({path:'api/auth/adminsendmeapassword',body:body})
        this.sendingreset = false
        this.message = res.message
      },
      async userOrders(sub){
        this.custorders = await this.get({path:'api/payments/stripegeneralusers/admingetorders/'+sub})
        console.log(this.custorders)
      },
      closeUser(){
        this.resetpassword=false
        this.activeuser=false
        this.dialog=false
        this.message=undefined
        this.string=undefined
        this.custorders = undefined
      }
    }
  }
</script>

<style scoped>
    .ol{
        border:solid thin green
    }
</style>